<template>
  <provider-container @mouseleave="hideTooltip">
    <slot />

    <tooltip-list-container :showTooltip="isVisible">
      <tooltip v-if="!!tooltip" v-bind="tooltip" :container-component="tooltipContainerComponent">
        <component :is="tooltipContentComponent" v-bind="tooltip" :chart-metadata="chartMetadata" />
      </tooltip>
    </tooltip-list-container>
  </provider-container>
</template>

<script>
import { ProviderContainer, TooltipListContainer } from './tooltip.styles';
import Tooltip from './tooltip.component';

export default {
  components: { ProviderContainer, TooltipListContainer, Tooltip },
  props: {
    chartMetadata: { type: Object },
    tooltipContainerComponent: { type: Object },
    tooltipContentComponent: { type: Object },
    eventBus: { type: Object },
  },
  data() {
    return {
      tooltip: null,
      isVisible: false,
    };
  },
  mounted() {
    this.eventBus.$on('show-tooltip', this.showTooltip);
    this.eventBus.$on('hide-tooltip', this.hideTooltip);
  },
  methods: {
    showTooltip({ key, data }) {
      this.hideTooltip();
      this.isVisible = true;
      this.tooltip = { ...data, key };
    },
    hideTooltip() {
      this.isVisible = false;
    },
  },
};
</script>
